import cardConstants from '../constants';

export function requestVisitorPass(qrCode) {
    return { type: cardConstants.GET_VISITOR_PASS_REQUESTED, qrCode };
}

export function receiveVisitorPass(qrCode, data) {
    return { type: cardConstants.GET_VISITOR_PASS_SUCCESS, data, qrCode };
}

export function requestVisitorPassFailed(qrCode, error) {
    return { type: cardConstants.GET_VISITOR_PASS_FAILURE, error };
}

export function requestCardData(qrCode) {
    return { type: cardConstants.GET_CARD_DATA_REQUESTED, qrCode };
}

export function receiveCardData(qrCode, data) {
    return { type: cardConstants.GET_CARD_DATA_SUCCESS, data, qrCode };
}

export function requestCardDataFailed(qrCode, error) {
    return { type: cardConstants.GET_CARD_DATA_FAILURE, error };
}

export function hideCardholderPage() {
    return { type: cardConstants.HIDE_CARDHOLDER_PAGE }
}

export function showCardholderPage(qrCode, context) {
    return { type: cardConstants.SHOW_CARDHOLDER_PAGE, qrCode, context }
}

export function hideVisitorPassPage() {
    return { type: cardConstants.HIDE_VISITOR_PASS_PAGE }
}

export function showVisitorPassPage(qrCode, context) {
    return { type: cardConstants.SHOW_VISITOR_PASS_PAGE, qrCode, context }
}